export function loadScriptBase({
    src,
    document,
    abortSignal,
    onBeforeLoad,
}: {
    src: string
    document: Document
    abortSignal?: AbortSignal
    onBeforeLoad?: (script: HTMLScriptElement) => void
}): Promise<HTMLScriptElement> {
    let loaded = false
    return new Promise<HTMLScriptElement>((resolve, reject) => {
        const script = document.createElement('script')

        abortSignal?.addEventListener('abort', () => {
            if (loaded) {
                return
            }

            script.remove()
            reject(new Error('Script aborted'))
        })

        script.onload = () => {
            loaded = true
            resolve(script)
        }

        script.onerror = (errorEvent: string | Event) => {
            if (loaded) {
                return
            }

            script.remove()
            reject(new Error('Failed to load script', { cause: errorEvent }))
        }

        onBeforeLoad?.(script)

        script.src = src

        document.body.appendChild(script)
    })
}
